import React, { Component } from 'react';
import { Modal, Icon, Row, Col, Button } from 'antd';
import http from '../../../axios/http';
import PdfView from '../../ui/PdfView'
import server from "../../../axios/server";
import messager from '../../ui/messager';
import { global_data } from '../../ui/auth'

class VehiclePurchaseDetail extends Component {
  state = {
    loading: false,
    visible: false,
    datail: {},
    checkReport:false,
    qrcode: '',
    pdfVisible: false
  }

  componentDidMount() {
    if (this.props.initDetail) {
      this.props.initDetail(this.initDetail);
    }
  }

  initDetail = (e) => {
    this.setState({ qrcode: '',datail: e.data,checkReport:false })
    this.getCheckReportStatus();
  }
  getCheckReportStatus(){
    http.post({
      url: '/vehicleOrder/verificationCheckReport',
      data: { orderNo: this.state.datail.orderNo },
      success: (res) => {
        //只要到这就说明有检测报告
        this.props.successCallback();
        this.setState({ checkReport:true});
      },
      error: (res) => {
        console.log(res);
      }
    })
  }

  previewPdf = (type) => {
    this.setState({ loading: true })
    let url = '';
    let fileName = '';
    url = '/vehicleContract/download'
    fileName = this.state.datail.buyerName + '车辆采购合同.pdf'
    this.setState({ pdfVisible: true })
    setTimeout(() => {
      let view = this.refs["pdfView"];
      view.loadFile({
        url: url,
        fileName: fileName,
        data: { 
          "orderNo": this.state.datail.orderNo,
          "withCheck":false
         },
        saveFile: false,
      });
    })
    this.setState({ loading: false })
  }

  previewCheckPdf(){
    if(this.state.checkReport){
      http.download({
        url: "/vehicleOrder/downloadCheckReport",
        data: { orderNo: this.state.datail.orderNo },
        fileName: this.state.datail.orderNo+"检测报告.pdf",
        success: (res) => {
            //this.setState({ loadingVisible: false });
        },
        error: (res) => {
            //this.setState({ loadingVisible: false });
        }
      });
    }else{
      messager.notify("无检测报告");
    }
  }

  hiddenPdflModal = () => {
    this.setState({
      pdfVisible: false,
    })
  }

  bindCancel = () => {
    Modal.confirm({
      title: '提示',
      content: '是否取消该订单？',
      okText: '确认',
      cancelText: '再想想',
      onOk: () => {
        http.get({
          url: '/vehicleOrder/cancel',
          data: { id: this.state.datail.id },
          success: (res) => {
            if(res.success){
              this.props.successCallback();
              this.props.onCancel();
              this.setState({ visible: false, loading: false });
            }else{
              messager.notify(res.errorMessage);
            }
          }
        })
      }
    });
  }

  bindSign = () => {
    Modal.confirm({
      title: '提示',
      content: '是否发给客户签约？',
      okText: '确认',
      cancelText: '再想想',
      onOk: () => {
        console.log('cancel', this.state.datail)
        if(this.state.datail.orderStatus===5||this.state.datail.orderStatus===21){
          this.props.successCallback();
          let qrcodeImg = `${server.httpServerUrl}/getWxQrCode?wxApp=manager&scene=${this.state.datail.id}&width=300&page=vehicleorder%2Fpurchase%2Fclient%2Fdetail`
          this.setState({ qrcode: qrcodeImg });
        }else{
          http.post({
            url: '/vehicleOrder/changeStatus',
            data: { orderNo: this.state.datail.orderNo, orderStatus: 21 },
            success: (res) => {
              if(res.success){
                this.props.successCallback();
                let qrcodeImg = `${server.httpServerUrl}/getWxQrCode?wxApp=manager&scene=${this.state.datail.id}&width=300&page=vehicleorder%2Fpurchase%2Fclient%2Fdetail`
                this.setState({ qrcode: qrcodeImg });
              }else{
                messager.notify(res.errorMessage);
              }
            }
          })
        }
        
      }
    });
  }

  render() {
    const { visible, onCancel } = this.props;
    return (
      <div>
        <Modal
          width={600}
          visible={visible}
          title="订单详情"
          okText="确定"
          cancelText="取消"
          maskClosable={false}
          onCancel={onCancel}
          onOk={this.setStatus}
          footer={null}
        >
          <Row>
            <Col span={2}></Col>
            <Col span={20}>
              <Row>
                <Col span={10} style={{ textAlign: "center" }}>
                  <div onClick={this.previewPdf.bind(this, 'LeaseContract')} style={{ width: "100%", border: "1px solid #ddd", margin: '0 auto', padding: '15px 0', cursor: 'pointer' }}>
                    <Icon type="file" className="table-operate-icon" style={{ fontSize: '30px' }} />
                    <div style={{ padding: "10px 0 1px" }}>旧机动车采购合同.pdf</div>
                    <span style={{ color: "#999", fontSize: '12px' }}>点击查看合同详情</span>
                  </div>
                </Col>
                <Col span={10} style={{ textAlign: "center",float:'right' }}>
                  <div onClick={this.previewCheckPdf.bind(this, 'LeaseContract')} style={{ width: "100%", border: "1px solid #ddd", margin: '0 auto', padding: '15px 0', cursor: 'pointer' }}>
                    <Icon type="file" className="table-operate-icon" style={{ fontSize: '30px' }} />
                    <div style={{ padding: "10px 0 1px" }}>{this.state.checkReport?"检测报告":"无关联检测订单"}</div>
                    <span style={{ color: "#999", fontSize: '12px' }}>点击下载</span>
                  </div>
                </Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>买家名称</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.buyerName}</Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>卖家名称</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.sellerName}</Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>车架号</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.vehicleOrderItemList ? this.state.datail.vehicleOrderItemList[0].vin : ''}</Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>厂牌型号</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.vehicleOrderItemList ? this.state.datail.vehicleOrderItemList[0].vehicleName : ''}</Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>车辆价格</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.vehicleOrderItemList ? this.state.datail.vehicleOrderItemList[0].price : ''}</Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>订单状态</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.orderStatusStr}</Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>订单编号</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.orderNo}</Col>
              </Row>
              <Row style={{ paddingTop: '15px' }}>
                <Col span={4}>生成时间</Col>
                <Col span={20} style={{ textAlign: "right" }}>{this.state.datail.createTime}</Col>
              </Row>
              {
                this.state.qrcode ?
                  <Row style={{ paddingTop: '15px' }}>
                    <Col span={24} style={{ textAlign: "center" }}>
                      <img alt='' style={{ width: '180px', height: '180px' }} src={this.state.qrcode} />
                      <p>打开微信扫一扫，把小程序卡片发给客户</p>
                    </Col>
                  </Row>
                  : ''
              }
              <Row style={{ paddingTop: '15px' }}>
                <Col span={24} style={{ textAlign: 'center' }}>
                  {
                    global_data.authCode.includes("VEHICLE_PURCHASE_INDEX_CANCEL")&&[3, 4].indexOf(this.state.datail.orderStatus) === -1 ?
                      <Button style={{ margin: '0 5px' }} onClick={this.bindCancel.bind(this)}>取消订单</Button>
                      : ''
                  }
                  {
                    global_data.authCode.includes("VEHICLE_PURCHASE_INDEX_SEND")&&[3, 4].indexOf(this.state.datail.orderStatus) === -1 ?
                      <Button type="primary" style={{ margin: '0 5px' }} onClick={this.bindSign.bind(this)}>发给客户签约</Button>
                      :
                      ''
                  }

                  {/* <Button style={{margin:'0 5px'}}>编辑订单</Button> */}

                </Col>
              </Row>
            </Col>
          </Row>

        </Modal>

        <Modal
          width={1250}
          visible={this.state.pdfVisible}
          title="合同预览"
          okText="确定"
          cancelText="取消"
          maskClosable={false}
          onCancel={this.hiddenPdflModal}
          onOk={this.print}
          zIndex={1000}
          footer={null}
        >
          {
            this.state.pdfVisible ?
              // <div style={{ position: 'absolute', top: '50%', left: '50%', zIndex: 1111, transform: ' translate(-50%, -50%)' }}>
              // <div style={{ height: this.state.clientH - 200, width:'700px', background: '#525659' }} >
              <div >
                <div style={{ height: '700px', width: '1200px', background: '#525659' }} >
                  <div style={{
                    color: '#333',
                    background: '#ffffff',
                    width: '100%',
                    textAlign: 'right',
                    paddingRight: 30,
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontSize: 20,
                  }}
                  >
                    {/* <span onClick={this.hiddenPdflModal} style={{ cursor: 'pointer' }}>X</span> */}
                  </div>
                  <PdfView ref="pdfView" />
                </div>
              </div> : ''
          }
        </Modal>

      </div>
    )
  }

}

export default VehiclePurchaseDetail;